module.exports = __webpack_public_path__ + "img/scene_wakeup_dw_big@2x.64666e97.png";